<script>
    import {click, goto, path, pattern} from "svelte-pathfinder";
    import {routes, current_page} from "../stores/router";
    import {user, fetching_user, refreshUser, registerUser} from "../stores/user";
    import LoginPage from "./pages/LoginPage.svelte";
    import PlannerPage from "./pages/PlannerPage.svelte";
    import Nav from "./Nav.svelte";
    import RegisterPage from "./pages/RegisterPage.svelte";
    import AuthJSSignInPage from "./pages/AuthJSSignInPage.svelte";
    import {deleteCookie, getCookie} from "../../lib/cookie";

    let cookie_contents = getCookie('register');
    if(cookie_contents !== null) {
        console.log('cookie found!', cookie_contents)
        goto('/register?processing=true');
        (async () => {
            await registerUser();
            deleteCookie('register');
            goto('/welcome');
        })()
    }


    let auth_state = {
        csrf: null,
        providers: null,
        fetching: true,
        failed_to_load_data: false
    };
    const urls = [
        '/api/auth/csrf',
        '/api/auth/providers',
    ];
    const fetchData = async () => {
        try {
            const response = await Promise.all(
                urls.map(url => fetch(url).then(res => res.json()))
            )
            console.log(response)
            auth_state.csrf = response[0].csrfToken;
            auth_state.providers = response[1];
            auth_state.fetching = false;
        }
        catch (err) {
            auth_state.failed_to_load_data = true;
            auth_state.fetching = false;
        }
    };
    fetchData();


    // TODO something smoother while $user.is_fetching so we don't get a flash of the login page
    let desired_page = null;
    $: if(!$fetching_user && $current_page.requires_sign_in && !$user.logged_in) {
        desired_page = $current_page.pattern;
        goto('/login?error=page_requires_login');
    }

    $: if($user.logged_in && desired_page !== null) {
        goto(desired_page);
        desired_page = null;
    }

    let test = false;
    $: if(!test && !$fetching_user && !$user.logged_in) {
        (async () => {
            let response = await fetch('/api/foo');
            console.log(response.status, await response.json());
            test = true;
        })()
    }

</script>

<!-- Handling all links in app via the svelte-pathfinder stores, see
https://github.com/sveltetools/svelte-pathfinder#using-helper-click -->
<svelte:window on:click={click} />

<Nav bind:auth_state></Nav>

{#if $fetching_user}
    &nbsp;
{:else}
    {#if $current_page.name === 'login'}
    <LoginPage></LoginPage>
    {:else if $current_page.name === 'register'}
    <RegisterPage></RegisterPage>
    {:else if $current_page.name === 'signin'}
    <AuthJSSignInPage bind:auth_state></AuthJSSignInPage>
    {:else if $current_page.name === 'welcome'}
    <h1>Welcome!</h1>
    <p>Please feel free to navigate to the <a href="/">home page</a></p>
    {:else if $current_page.name === 'home'}
    <PlannerPage></PlannerPage>
    {/if}
{/if}

<!-- Some comments for getting tailwind to pick-up otherwise un-findable styles that we want present:

-->

<style global lang="postcss">
    /* only apply purgecss on utilities, per Tailwind docs */
    /* purgecss start ignore */
    /* imports using postcss-import for 'external' CSS - must come first!! */
    /* eg @import 'filepond/dist/filepond.css'; */
    @tailwind base;
    @tailwind components;
    @tailwind forms;
    /* purgecss end ignore */

    @tailwind utilities;
</style>